import { Component ,  OnInit , Input , AfterViewInit , ViewChild , ElementRef , forwardRef, EventEmitter, Output, HostListener, ChangeDetectorRef} 	from '@angular/core';
import { ControlValueAccessor  , NG_VALUE_ACCESSOR } 						from '@angular/forms';

import jQuery from 'jquery';


@Component({
        standalone: false,
  selector: 'uikit-multiselect-dropdown',
  templateUrl: "./uikit.multiselect.dropdown.comp.html",
  providers : [ 
				  { 
					  provide: NG_VALUE_ACCESSOR,
					  useExisting: forwardRef(() => UiKitMultiSelectDropdownComp),
					  multi: true
					}
			  ],
  styles : [
	  `
	  .ui_input .m-drop-new li.non-selectable:hover{color:#222a34; background : none;}
	  `
	]
})
export class UiKitMultiSelectDropdownComp implements OnInit , AfterViewInit , ControlValueAccessor {

			
		@Output() change = new EventEmitter<string>();
		@Output() focus = new EventEmitter<boolean>();

		@Input() items:any;
		@Input() marginTop:boolean = true;
		@Input() valueProperty:any;
		@Input() labelProperty:any;
		@Input() height:string;
		@Input() withScrollBar:string = 'false';
		@Input() firstSelectedOption:string = null;
		@Input() readOnly:any = null;
		@Input() searchable:boolean = false;
		@Input() labelAlign:string = null;
		
		onTouched: any = () => {};

		_scrollbarStr:boolean = false;
		_heightStr:string = "50px";
		_fldFocus:boolean = false;
		fldTouched:boolean = false;		
		propagateChange = (_: any) => {};
		
		_value:any = null;
		initialized:boolean = false;

		allSelectList:any[] = [];
		isMobile:boolean = false;
    constructor(private _el: ElementRef, private _cdRef:ChangeDetectorRef){
    }

	itemsCopy:any[] = null;
    ngOnInit(){
		//console.info(" scrollbar style now ");
		if( this.withScrollBar == 'true'){
			this._scrollbarStr = true;
		}
			
		if( this.height != null )
			this._heightStr = this.height;
		else 
			this._heightStr = "50px";

		if( this.items != null ){
			this.itemsCopy = JSON.parse(JSON.stringify(this.items));
		}
		this.isMobile = jQuery(window).width() < 768;
		this.initialized=true;
    }
		
	ngAfterViewInit() {
	}
	
	@HostListener("window:resize", ["$event"])
	onWindowResized(event:any) {
		//console.info( "jQuery(window).width() : "+ );
		this.isMobile = jQuery(window).width() < 768;
	}

	writeValue( value: any ) {
		/*if( value != null )
			console.info( " writing value now value.length : "+ value.length);
		else 
			console.info( " value is null  : ");*/
		this.allSelectList = [];
		if( value != null && value.length > 0 && this.valueProperty == null && this.labelProperty==null ){
			for( var ctr = 0; ctr < value.length; ctr++){
				for( var i = 0; i < this.items.length; i++){
					if( this.items[i] == value[ctr]){
						this.allSelectList.push( this.items[i] );
					}
				}
			}
		}else if( value != null && value.length > 0 && this.valueProperty != null && this.labelProperty!=null ){
			for( var ctr = 0; ctr < value.length; ctr++){
				for( var i = 0; i < this.items.length; i++){
					if( this.items[i][this.valueProperty] == value[ctr][this.valueProperty]){
						this.allSelectList.push( this.items[i] );
					}
				}
			}
		}
		this._value = value;
		//console.info( " writing value ....");
	}
	
	registerOnChange(fn:any) {
		this.propagateChange = fn;
	}

	registerOnTouched(fn:any) {
		this.onTouched = fn;
	}
		
	valueChange( item:any ){
		if( this.allSelectList.length == 0 ){
			this.allSelectList.push( item );
		}else if( this.allSelectList.length > 0 && this.allSelectList.indexOf(item)!=-1 ){
			var index = this.allSelectList.indexOf(item);
			this.allSelectList.splice( index , 1);
		}
		else if( this.allSelectList.length > 0 && this.allSelectList.indexOf(item)==-1 ){
			//var index = this.allSelectList.indexOf(item);
			this.allSelectList.push( item );
		}

		if( this.searchable == true  && item != null && item == "" ){
			this._value = null;
			this.fldFocus = false;
			this.propagateChange( this.allSelectList );
		}
		else {
			this._value = item;
			this.fldFocus = false;
			this.propagateChange( this.allSelectList );
		}

		this.change.emit( this._value );
	}
	
	
	_enable:boolean = true;
	setDisabledState(isDisabled: boolean) : void{
		this._enable = !isDisabled;
		if( this._enable == false ){
			this.readOnly = true;
		}
	}

	set fldFocus( val:boolean ){
		this._fldFocus = val;
		this.onTouched( this._value );
		//this.fldTouched = true;
	}

	get fldFocus( ):boolean {
		return this._fldFocus;
	}

	isActive( item:any ):boolean {
		if( item == null ){
			return false;
		}
		else if( item != null && this.valueProperty != null ){
			for( var ctr = 0; ctr < this.allSelectList.length; ctr++){
				if ( item[this.valueProperty] == this.allSelectList[ctr][this.valueProperty]){
					return true;
				}
			}
			
		}
		else if( item != null && this.valueProperty == null ){
			for( var ctr = 0; ctr < this.allSelectList.length; ctr++){
				if ( item == this.allSelectList[ctr] )
					return true;
			}
		}
		return false;
	}

	showValue( item:any ){
		if( item != null && this.valueProperty != null && this.labelProperty!=null ){
			return item[this.labelProperty];
		}
		else if( item != null && this.valueProperty == null ){
			return item;
		}
	}

	getFilteredValue(filter:string){
		if( filter != null && this.valueProperty != null && this.labelProperty!=null && this._value[this.labelProperty]!=undefined){
			return this._value[this.labelProperty];
		}
		else if( ( this._value == null || this._value == "" ) && this.firstSelectedOption!=null){
			return this.firstSelectedOption;
		}
			return this._value;
		//return this.firstSelectedOption==null?"Select":this.firstSelectedOption;
	}

	getValue(){
		var value = "";
		var value2 = "";
		var counter = 0;
		if( this._value != null && this.valueProperty != null && this.labelProperty!=null){

			for( var ctr = 0; ctr < this.allSelectList.length; ctr++){
				if( counter == 0){
					value = this.allSelectList[ctr][this.labelProperty];
				}
				else if( counter == 1){
					value2 = this.allSelectList[ctr][this.labelProperty];
				}
				counter++;
			}

		}
		else if( this._value != null && this.valueProperty == null && this.labelProperty==null ){
			for( var ctr = 0; ctr < this.allSelectList.length; ctr++){
				if( counter == 0){
					value = this.allSelectList[ctr];
				}
				else if( counter == 1){
					value2 = this.allSelectList[ctr];
				}
				counter++;
			}
		}

		if( this.isMobile == true ){
			if( counter >= 2){
				return value+" [+ "+(counter-1)+"]";
			}
	
		}else if( this.isMobile == false ){
			if( counter >= 3){
				return value+","+value2+" [+ "+(counter-2)+"]";
			}
			else if( counter == 2){
				return value+", "+value2;
			}
		}
		return value;
	}

	@HostListener("document:click", ["$event"])
	onDocumentClicked(event:any) {
		if( event.target != null && this.fldFocus==true && this._el!=null && (!this._el.nativeElement.contains(event.target) )){
			//console.info( " onDocumentClicked : this._value : " + this._value );
			this.fldFocus = false;
		}
		/*if(event.target != null && this.slotDurationDropDownVisible==true && document.getElementById("durationDropDown")!=undefined && (!document.getElementById("durationDropDown").contains(event.target) )){
			console.info(" hide drop down now...");
			this.slotDurationDropDownVisible = false;
		}*/
	}

	toggleField(){
		//console.info( "typeof "+ (typeof(this.readOnly)));
		if( this.searchable == false ){
			return ;
		}
		if( this.readOnly == 'true' || this.readOnly == true ){
			this.fldFocus = false;
			return ;
		} 
		this.fldFocus=!this.fldFocus;
		if( this.focus != null ){
			this.focus.emit( this.fldFocus );
		}
	}

	filterTimezoneList(event:any){
		if( this.fldFocus == false ){
			this.toggleField();
		}
		if( this._enable == false ){
			console.info( " field is not enabled --------");
			return ;
		}
		let str:any = null;
		let value:string = event.target.value;
		//console.info(" event.keyCode :  " + event.keyCode);
		if(event.keyCode == 8){
			str = event.target.value;
			try{
				str = str.substring( 0 , str.length - 1);
			}catch(e){}
		}
		else if(value == "" && event.keyCode == 27 ){
			this.fldFocus = false;
		}

		else if((event.keyCode == 27 || event.keyCode == 9) && value != ""){

			//event.target.value = "";
			//var val = this.getValue();
			var narray = this.getNewArray( value );
			//console.info(" narray.length "+ narray.length);
			if( narray.length == 1 ){
				this.valueChange( narray[ 0 ] );
			}

			if( this._value != null ){
				//console.info(" clearing the text field ");
				event.target.value = this.getValue();
			}else if( this._value == null && this.firstSelectedOption != null ){
				event.target.value = this.firstSelectedOption;
			}else {
				event.target.value = "";
			}
			str = "";
			this.fldFocus = false;
		}
		else if((event.keyCode == 27 || event.keyCode == 9) && value == ""){
			this._value = null;
			event.target.value = this.getValue();
			//console.info(" hide the menu now ");
			this.fldFocus = false;
		}
		else if(event.key && event.key.length > 1){
			str = event.target.value;
		}
		else 
			str = event.target.value+event.key;
		
		//console.info(" filterTable(value:string) : "+str);		
		if( str == null){
			return ;
		}

		setTimeout( ()=>{
			if( str != "" ){
				var array = this.getNewArray( str );
				//console.info(" filterTable(value:string) : "+str);
				
				if(array.length>0)
					this.items = array;
			}
			else {
				this.items = JSON.parse(JSON.stringify(this.itemsCopy));
			}
			this._cdRef.detectChanges();
		} , 15);
	}

	focusLost(event:any){
		//this.fldFocus = false;
		//console.info( " is value null : "+ (this._value == null ));
		this.filterTimezoneList( event );
	}

	focusIn(event:any){
		if( this._enable == false ){
			this.fldFocus = false;
			return;
		}
		this.fldFocus = true;
		//console.info( this.fldFocus+ ": this.fldFocus "+ (this._value == null ));
		if( this.focus != null ){
			this.focus.emit( this.fldFocus );
		}
	}

	getNewArray( str:string ){
		var array = [];
		for( var i = 0; i < this.itemsCopy.length; i++){
			if( this.labelProperty != null ){
				if( this.itemsCopy[i][this.labelProperty].toLowerCase().indexOf(str.toLowerCase()) != -1){
					array.push(this.itemsCopy[i]);
				}
			}else {
				if( this.itemsCopy[i].toLowerCase().indexOf(str.toLowerCase()) != -1){
					array.push(this.itemsCopy[i]);
				}
			}

		}
		return array;
	}
}